import { render } from "./ArgonLookup.vue?vue&type=template&id=a6276a5c&scoped=true"
import script from "./ArgonLookup.vue?vue&type=script&lang=js"
export * from "./ArgonLookup.vue?vue&type=script&lang=js"

import "./ArgonLookup.vue?vue&type=style&index=0&id=a6276a5c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a6276a5c"]])

export default __exports__